import WidgetStyles from '../WidgetStyles';
import Accordion from '../Accordion';
import CurrentFamily, {CurrentFamilyOptions} from './CurrentFamily';
import Display, {DisplayOptions} from './Display';
import {Fill} from '@wordpress/components';
import PostType, {PostTypeOptions} from './PostType';
import type {BlockEditProps} from '@wordpress/blocks';
import type {Type} from '@wordpress/api/types';
import ExcludeField from '../ExcludeField';
import type {WithCommon} from '../navigation/block';
import Order, {type OrderOptions} from './Order';

type BasicAttr = {
	// Attr
	exclude: string;
	order_by: string;

	// DisplayOptions
	display_all?: boolean;
	include_childless_parent?: boolean;
	include_parent?: boolean;
	levels: number;
}

export type SetAttributes = ( newValue: {
	[attribute in keyof WithCommon<Attr>]?: WithCommon<Attr>[attribute]
} ) => void;

export type Attr = BasicAttr
	& CurrentFamilyOptions
	& DisplayOptions
	& PostTypeOptions
	& OrderOptions;


export type FillProps =
	Pick<BlockEditProps<WithCommon<Attr>>, 'clientId' | 'attributes' | 'setAttributes'>
	&
	{
		type?: Type<'edit'>,
		name: 'advanced-sidebar-menu/pages'
	};


type Props = Record<string, never>;

const ErrorBoundary = window.ADVANCED_SIDEBAR_MENU.ErrorBoundary;

/**
 * Pages block content in the editor.
 */
const Edit = ( {}: Props ) => {
	return ( <>
		<Fill<FillProps> name="advanced-sidebar-menu/pages/display">
			{( {attributes, setAttributes, type, name} ) => (
				<ErrorBoundary
					attributes={attributes}
					block={name}
					section={'pro/pages/Edit/display'}
				>
					<Display
						type={type}
						attributes={attributes}
						setAttributes={setAttributes} />
				</ErrorBoundary>
			)}
		</Fill>

		<Fill<FillProps> name="advanced-sidebar-menu/pages/general">
			{( {attributes, setAttributes, name} ) => (
				<ErrorBoundary
					attributes={attributes}
					block={name}
					section={'pro/pages/Edit/general'}
				>
					<PostType attributes={attributes} setAttributes={setAttributes} />
				</ErrorBoundary>
			)}
		</Fill>

		<Fill<FillProps> name="advanced-sidebar-menu/pages/general-after">
			{( {attributes, setAttributes, name} ) => (
				<ErrorBoundary
					attributes={attributes}
					block={name}
					section={'pro/pages/Edit/general-after'}
				>
					<Order attributes={attributes} setAttributes={setAttributes} />
				</ErrorBoundary>
			)}
		</Fill>

		<Fill<FillProps> name="advanced-sidebar-menu/pages/inspector">
			{( {attributes, setAttributes, type, name} ) => (
				<ErrorBoundary
					attributes={attributes}
					block={name}
					section={'pro/pages/Edit/inspector'}
				>
					<ExcludeField
						attributes={attributes}
						setAttributes={setAttributes}
						block={name}
						type={type} />
					<Accordion
						type={type}
						attributes={attributes}
						setAttributes={setAttributes} />
					<CurrentFamily
						attributes={attributes}
						setAttributes={setAttributes}
						type={type} />
				</ErrorBoundary>
			)}
		</Fill>

		<Fill<FillProps> name="advanced-sidebar-menu/pages/block-controls">
			{( {attributes, setAttributes, name} ) => (
				<ErrorBoundary
					attributes={attributes}
					block={name}
					section={'pro/pages/Edit/block-controls'}
				>
					<WidgetStyles
						attributes={attributes}
						setAttributes={setAttributes} />
				</ErrorBoundary>
			)}
		</Fill>
	</> );
};


export default Edit;
